import { toggleFullScreen } from 'helpers/player';

const shaka = require('external/shaka-player.ui.debug');

const PlayPauseOverlay = class extends shaka.ui.Element {
  _clickDelayTimer: number;

  constructor(parent: typeof PlayPauseOverlay, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('div') as HTMLDivElement;
    this.button_.classList.add('shaka-play-pause-overlay');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'dblclick', (event: Event) => {
      window.clearTimeout(this._clickDelayTimer);
      event.preventDefault();
      event.stopImmediatePropagation();

      const video = this.player.getMediaElement() as HTMLVideoElement;
      toggleFullScreen(video);
    });

    this.eventManager.listen(this.button_, 'click', () => {
      window.clearTimeout(this._clickDelayTimer);
      this._clickDelayTimer = window.setTimeout(() => {
        controls.onPlayPauseClick_();
      }, 200);
    });
  }
};

// Factory that will create a button at run time.
PlayPauseOverlay.Factory = class {
  create(rootElement, controls) {
    return new PlayPauseOverlay(rootElement, controls);
  }
};

export default PlayPauseOverlay;
